export default __webpack_public_path__ + "static/media/2_0056.da91e0c9.webp";